import { ErrorPage, ErrorPageType } from '@exam-management/components';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { useQBankStructure } from '@exam-management/qbs-provider';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function QBankStructureDashboardLayout() {
  const { pageAccessibility } = useQBankStructure();

  if (!pageAccessibility.dashboard) {
    return <ErrorPage errorType={ErrorPageType.NO_PERMISSION} />;
  }

  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.QBANK.DASHBOARD.VIEW}>
      <Outlet />
    </PermissionGuard>
  );
}
